import React, { Component } from "react";
import { Modal as AModal } from "antd";

import "./index.less";

class Modal extends Component {
  render() {
    const open = "open" in this.props ? this.props.open : true;
    return (
      <AModal
        className="nano-modal"
        maskClosable={false}
        {...this.props}
        open={open}
        footer={this.props.footer || null}
      >
        {this.props.children}
      </AModal>
    );
  };
}

Modal.info = AModal.info;

Modal.success = AModal.success;

Modal.error = AModal.error;

Modal.warning = AModal.warning;

Modal.confirm = AModal.confirm;

export default Modal;
